export default __webpack_public_path__ + "static/media/circleTick.e30134fe.svg";